module.exports = __webpack_public_path__ + "img/popup-shareMin.3137da73.svg";